import { Form as FormInitial, Row, Col, Space, message } from 'antd';
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { DownloadOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
  ModalItem,
  ButtonItem,
  FormItem,
  InputItem,
  Form,
  ErrorItem
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import facturaCompraPdf from "../../../../Pdf/facturaCompraPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalMandarCorreoFacturas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pdf: null,
      // Tipo resuelto por el servidor, para los llamadores que abren una factura
      // por id sin saber de que tipo es (el Kardex). Si viene la prop, manda la prop.
      tipoFacturaResuelto: null,
    };
    this.formRef = React.createRef();
    this.iframeRef = React.createRef();

    this.cerrarModalMandarCorreoFacturas = this.cerrarModalMandarCorreoFacturas.bind(this);
    this.onFinish = this.onFinish.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        this.consultarTodo();
      } else {
        // Limpiar para que al reabrir con otra factura no quede el tipo anterior.
        this.setState({ pdf: null, tipoFacturaResuelto: null });
      }
    }
  }

  tipoFacturaActual() {
    return this.props.tipoFactura || this.state.tipoFacturaResuelto;
  }

  /**
   * El name del iframe se arma con el tipo de factura, que cuando lo resuelve el
   * servidor cambia entre el primer render y la respuesta. Por eso se busca por ref
   * (con reintentos) en vez de por window.frames[...] a secas.
   */
  abrirEnIframe(pdf, tipoFactura, intento = 0) {
    const frame =
      this.iframeRef.current?.contentWindow || window.frames[`${tipoFactura}Pdf`];
    if (frame) {
      pdf.open({}, frame);
      return;
    }
    if (intento < 10) {
      setTimeout(() => this.abrirEnIframe(pdf, tipoFactura, intento + 1), 100);
    }
  }

  async consultarTodo() {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "facturas/datosPdf",
        { facturaId: this.props.id, empresaId: this.props.empresaId, tipoFactura: this.props.tipoFactura },
        { headers: this.props.headersToken }
      );

      const tipoFactura = this.props.tipoFactura || res.data?.tipoFactura;
      const pdf = pdfMake.createPdf(facturaCompraPdf(res.data, tipoFactura));
      this.setState(
        {
          loading: false,
          pdf: pdf,
          tipoFacturaResuelto: res.data?.tipoFactura ?? null,
        },
        () => {
          this.abrirEnIframe(pdf, tipoFactura);
        }
      );
    } catch (error) {
      console.error("Error al consultar los datos:", error);
      this.setState({ loading: false });
    }
  }

  async descargarFactura(value) {

    try {
      const res = await axios.post(
        "facturas/datosPdf",
        { facturaId: this.props.id, empresaId: this.props.empresaId,  tipoFactura: this.tipoFacturaActual() },
        { headers: this.props.headersToken }
      );

      const numero = (res.data?.respuestaFactura?.dataSat?.Serie || '') + '_' + (res.data?.respuestaFactura?.dataSat?.Folio || '')

      const tipoFactura = this.props.tipoFactura || res.data?.tipoFactura;

      pdfMake.createPdf(facturaCompraPdf(res.data, tipoFactura)).download(`Factura_${tipoFactura}_${numero}.pdf`);

    } catch (error) {
      console.error("Error al consultar los datos:", error);
      this.setState({ loading: false });
    }
  }

  cerrarModalMandarCorreoFacturas() {
    this.props.cerrarModalMandarCorreoFacturas();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (values?.correosEnvio?.length > 0) {
      this.setState({ loading: true });
      const tipoFactura = this.tipoFacturaActual();
      axios
        .post(
          "facturas/enviarFactura",
          { ...values, facturaId: this.props.id, empresaId: this.props.empresaId, tipoFactura },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success(`Factura ${tipoFactura} enviada`);
            this.formRef.current.resetFields();
            this.cerrarModalMandarCorreoFacturas();
          } else if (res.data.success === 1) {
            message.error(`No se pudo enviar la factura ${tipoFactura} a ese correo`);
          } else {
            message.error("Sucedió un error y no se pudo enviar");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al enviar el correo");
          console.error("Error:", error);
        });
    } else {
      message.info('Proporcione al menos un correo de envío');
    }
  }


  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModalMandarCorreoFacturas}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="mandarCorreo"
          layout
          width={700}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: '' }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label="Correo"
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ? (
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                ) : null}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                icon={<DownloadOutlined />}
                blanco={true}
                onClick={() => this.descargarFactura()}
              >
                Descargar
              </ButtonItem>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarModalMandarCorreoFacturas} // Removido el bind aquí ya que fue enlazado en el constructor
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>

        <iframe
          ref={this.iframeRef}
          title={`Factura ${this.tipoFacturaActual() || ""}`}
          style={{ width: "100%", height: "100vh" }}
          id={`${this.tipoFacturaActual()}Pdf`}
          name={`${this.tipoFacturaActual()}Pdf`}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalMandarCorreoFacturas);
